import $ from 'jquery';
import Cards from '@/lib/cards.js';
import { SearchField } from 'vue-bootstrap';
import Vue from 'vue';

export default function () {
	const cards = new Cards();
	cards.setup('ul.cards', 'li', 'masonry');

	/**
	 * Filtertron
	 */
	$('.filtertron').filtertron('entries', {
		expander: '#filtertronExpander',
		cards: cards,
	});

	/**
	 * Category selector
	 */
	const categorySelectorEl = document.getElementById('category-selector');

	if (categorySelectorEl) {
		const categorySelector = new Vue({
			el: categorySelectorEl,
			name: 'GalleryApp',
			components: {
				SearchField,
			},
		});

		$(document).one('pjax:end', () => {
			categorySelector.$destroy();
		});
	}
}
